module.exports = __webpack_public_path__ + "assets/img/smsimg2.98d41eaa.png";